import {Button} from "antd";
import parse from "html-react-parser";
import React, {ReactNode, useState} from 'react'
import {Wheel} from 'react-custom-roulette'
import {WheelData} from "react-custom-roulette/dist/components/Wheel/types";
import buttonGif from "../../assets/images/wheel-button.png";
import FirebaseService from "../../core/services/firebase.service";
import "./Wheel4p.scss";

interface IProps {
  isTicketUsed: boolean;
  wheelData: WheelData[];
  winnerIndex: number;
  callbackFinished: () => void;
  callbackGoToBip: () => void;
  callbackOtherService: () => void;
}

const Wheel4P = (props: IProps) => {
  const [mustSpin, setMustSpin] = useState(false);

  const handleSpin = () => {
    setMustSpin(true);
  }

  const handleStop = (): void => {
    props.callbackFinished();
  }

  const renderOverlay = (): ReactNode => {
    return (
      <div className="overlay">
        <p className="info">
          {parse(FirebaseService.getValue(FirebaseService.wheel_no_right_text))}
        </p>
        <div className="button-wrapper">
          <Button
            className="button button-blue"
            onClick={props.callbackGoToBip}
          >
            {parse(FirebaseService.getValue(FirebaseService.wheel_no_right_button1))}
          </Button>

          <Button
            className="button button-yellow"
            onClick={props.callbackOtherService}
          >
            {parse(FirebaseService.getValue(FirebaseService.wheel_no_right_button2))}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div id="wheel4p">
      <Wheel
        mustStartSpinning={mustSpin}
        data={props.wheelData}
        prizeNumber={props.winnerIndex}
        onStopSpinning={handleStop}
        outerBorderColor="black"
        outerBorderWidth={10}
        innerRadius={22}
        innerBorderColor="transparent"
        innerBorderWidth={5}
        radiusLineColor="black"
        radiusLineWidth={2}
        fontSize={18}
        textDistance={60}
      />
      <Button
        className="button-spin"
        disabled={mustSpin}
        onClick={handleSpin}
      >
        {
          mustSpin
            ? parse(FirebaseService.getValue(FirebaseService.wheel_button))
            : <img className="button-gif" src={buttonGif} alt="button"/>
        }
      </Button>
      {props.isTicketUsed && renderOverlay()}
    </div>
  )
}

export default Wheel4P;
